import React, { useState } from 'react';
import styled from "styled-components";
import Button, { ButtonProps } from '@material-ui/core/Button';
import { Input } from '../components/Input';
import { NumberInput } from '../components/NumberInput';
import { Flex, DeleteIconButton } from '../styles/global';
import deleteIcon from "../assets/delete.svg";

interface Props {
    shopItems?: any,
    setValue: (value: any) => void;
}

export const ShopItem = ({ shopItems, setValue }: Props) => {
    const [shopItemList, setShopItemList] = useState(shopItems || []);

    return (
        <div>
            {shopItemList.map((shopItem: any, index: number) => {
                return (
                    <ShopItemContainer key={index} alignItems="center">
                        <Input
                            setWidth={300}
                            setValue={(value: string) => {
                                let newShopItemList = [...shopItemList];
                                newShopItemList[index].item_name = value;
                                setShopItemList(newShopItemList);
                                setValue(newShopItemList);
                            }}
                            value={shopItemList[index]?.item_name}
                            required
                            requiredString="Shop item name required"
                        />
                        <div style={{ marginRight: '16px' }} />
                        <NumberInput
                            setWidth={120}
                            setValue={(value: number) => {
                                let newShopItemList = [...shopItemList];
                                newShopItemList[index].item_price = value;
                                setShopItemList(newShopItemList);
                                setValue(newShopItemList);
                            }}
                            value={shopItemList[index]?.item_price}
                            required
                            requiredString="Price required"
                        />
                        <DeleteIconButton
                            style={{ marginLeft: '12px' }}
                            onClick={() => {
                                let newShopItemList = [...shopItemList];
                                newShopItemList.splice(index, 1);
                                setShopItemList(newShopItemList);
                                setValue(newShopItemList);
                            }}
                        >
                            <img src={deleteIcon} style={{ height: 24 }} alt="delete" />
                        </DeleteIconButton>
                    </ShopItemContainer>
                );
            })}
            <StyledButton
                size="large"
                variant="contained"
                disableElevation
                onClick={() => {
                    const newShopItemList = [...shopItemList];
                    newShopItemList.push({ item_name: "", item_price: 0 });
                    setShopItemList(newShopItemList);
                    setValue(newShopItemList);
                }}
            >
                Add Shop Item
            </StyledButton>
            <div style={{ fontSize: '12px', color: '#718096', marginTop: '12px' }}>Supported items are: Mask, PPE, Vaccine, Medication, Food, Test, Sequencing, and Apparel (keep word case)</div>
        </div>

    );
}

const StyledButton = styled(Button) <ButtonProps>`
  && {
    max-width: 280px;
  }
` as typeof Button;

const ShopItemContainer = styled(Flex)`
  margin-top: 24px;
  margin-bottom: 12px;
`;
